import React from 'react';
import { Paper as MuiPaper, PaperProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

const formPaperStyles = {
  p: { xs: 2, sm: 3 },
  border: '1px solid',
  borderColor: 'softBorder',
  borderRadius: 2,
  bgcolor: 'background.paper',
  backgroundImage: 'none',
  boxShadow: 'none',
};

const Paper = React.forwardRef<HTMLDivElement, PaperProps>(
  ({ elevation = 0, sx, ...props }, ref) => {
    const combinedStyles = (sx
      ? [formPaperStyles, sx]
      : formPaperStyles) as SxProps<Theme>;

    return (
      <MuiPaper {...props} ref={ref} elevation={elevation} sx={combinedStyles} />
    );
  }
);

Paper.displayName = 'Paper';

export { Paper };
